import { KeyValueMap } from "../../redux/slices/appState/models";
import { LANGUAGE_CODE } from "./common";

export const commonSiteCoreKeys = {
  //below are the navigation site core key
  commonHeaderKey: "Header",
  headerLanguageKey: "Header.LanguageList",
  headerLastLogin: "Header.LastLogin",
  preferredLanguageSaved: "Header.PreferredLanguageSaved",
  updatingPreferredLanguage: "Header.UpdatingPreferredLanguage",
  headerLogo: "Header.HeaderLogo",
  headerLogoMobile: "Header.HeaderLogo-Mobile",
  smallImage: "SmallImage",
  mediumImage: "MediumImage",
  //below are common parent key
  commonComponentKey: "CommonComponent",
  commonValidationKey: "Common.ValidationMessages",
  commonBEValidationKey: "Common.BEValidationMessages",
  commonTaxDetailsKey: "Common.TaxDetails",
  commonBillingConfigurationDetailsKey: "Common.BillingConfigurationDetails",
  //below are common label key
  show: "Common.Show",
  online: "Common.Online",
  with: "Common.With",
  hour: "Common.Hr",
  hours: "Common.Hrs",
  note: "Common.Note",
  of: "Common.Of",
  inputPlaceHolder: "Common.EnterPlaceholderText",
  selectPlaceHolder: "Common.Select",
  selectAllPlaceHolder: "Common.SelectAll",
  declineAllPlaceHolder: "Common.Decline-NoneOfTheBelow",
  telephonePlaceHolder: "Common.TelephonePlaceholderText",
  emailPlaceHolder: "Common.EmailPlaceholderText",
  savedFilter: "Common.SavedFilters",
  saveFilter: "Common.SaveFilter",
  clearAll: "Common.ClearAll",
  search: "Common.Search",
  edit: "Common.Edit",
  view: "Common.View",
  viewMore: "Common.ViewMore",
  go: "Common.Go",
  minutes: "Common.Minutes",
  export: "Common.Export",
  exportToExcel: "Common.ExportToExcel",
  goToPage: "Common.GoToPage",
  noResult: "Common.NoResultsFound",
  noRecordsFound: "Common.NoRecordsFound",
  parent: "Common.Parent",
  searchCriteria: "Common.EnterSearchCriteria",
  cancel: "Common.Cancel",
  cancelActionText: "Common.CancelButtonActionText",
  continue: "Common.Continue",
  tag: "Common.Tag",
  viewLocale: "Common.ViewLocale",
  close: "Common.Close",
  update: "Common.Update",
  upload: "Common.Upload",
  restore: "Common.Restore",
  uploadingPleaseWait: "Common.UploadingPleaseWait",
  confirmation: "Common.Confirmation",
  save: "Common.Save",
  yes: "Common.Yes",
  no: "Common.No",
  confirm: "Common.Confirm",
  collapseAll: "Common.CollapseAll",
  expandAll: "Common.ExpandAll",
  delete: "Common.Delete",
  someThingWentWrongPleaseTryAgainLater:
    "Common.SomethingWentWrongPleaseTryAgainLater",
  loadingPleaseWait: "Common.LoadingPleaseWait",
  errorsIdentified: "Common.ErrorsIdentified",
  rowsPerPage: "Common.Rowsperpage",
  ok: "Common.OK",
  createdDate: "Common.CreatedDate",
  selectedCountries: "Common.SelectedCountries",
  brazilPlaceholder: "Common.EnterBrazilPlaceholderText",
  frenchPlaceholder: "Common.EnterFrenchPlaceholderText",
  japanesePlaceholder: "Common.EnterJapanesePlaceholderText",
  manageLocale: "Common.ManageLocale",
  locale: "Common.Locale",
  warning: "Common.Warning",
  countryBusinessRuleListParent: "Common.CountryBusinessRuleList",
  countryBusinessRuleList: "CountryBusinessRulesList",
  dateInputPlaceHolder: "Common.DateFormatPlaceholderText",
  notes: "Common.Notes",
  next: "Common.Next",
  cancelButtonActionText: "Common.CancelButtonActionText",
  closeButtonActionText: "Common.CloseButtonActionText",
  saveButtonActionText: "Common.SaveButtonActionText",
  waitSaving: "Common.WaitSaving",
  leavingPageActionText: "Common.LeavingPageActionText",
  discardChangesText: "Common.AreYouSureYouWantToDiscardTheChanges",
  discardChangesGivenInfoWillLostText:
    "Common.AreYouSureYouWantToDiscardTheChangesTheGivenInformationWillBeLost",
  waitWorking: "Common.WaitWorking",
  cancelChanges: "Common.CancelChanges",
  cancelButtonAlertText: "Common.CancelButtonAlertText",
  information: "Common.Information",
  changesSavedMessage: "Common.ChangesSavedMessage",
  markAsActive: "Common.MarkAsActive",
  markAsExpired: "Common.MarkAsExpired",
  unmap: "Common.Unmap",
  undoCancel: "Common.UndoCancel",
  archive: "Common.Archive",
  comment: "Common.Comment",
  comments: "Common.Comments",
  global: "Common.Global",
  hierarchy: "Common.Hierarchy",
  modify: "Common.Modify",
  download: "Common.Download",
  stateProvincePlaceHolder: "Common.StateProvincePlaceHolderText",
  na: "Common.NA",
  success: "Common.Success",
  statusList: "Common.StatusList",
  applyNecessaryFiltersMessage: "Common.ApplyNecessaryFiltersMessage",
  refineYourSearchInformationMessage:
    "Common.RefineYourSearchInformationMessage",
  typeToSearchPlaceholder2Chars: "Common.TypeToSearchTwoCharsPlaceholderText",
  typeToSearchPlaceholder3Chars: "Common.TypeToSearchPlaceholderText",
  add: "Common.Add",
  copied: "Common.Copied",
  more: "Common.More",
  invoiceHistory: "Common.InvoiceHistory",
  validate: "Common.Validate",
  details: "Common.Details",
  reOpen: "Common.ReOpen",
  downloadInvoice: "Common.DownloadInvoice",
  allRecords: "Common.AllRecords",
  fineTuningSearchCriteriaMessage: "Common.FineTuningSearchCriteriaMessage",

  //below are the validation message key
  enterValidPageNumber: "ValidationMessages.EnterValidPageNumber",
  pageNumberRequired: "ValidationMessages.PageNumberRequired",
  requiredValidation: "ValidationMessages.RequiredFieldValidatorWithToken",
  enterValidValidation: "ValidationMessages.EnterValidNamewithToken",
  enterFieldValueValidator:
    "ValidationMessages.EnterFieldValueValidatorWithToken",
  onlyAlphanumericSpacesAllowed:
    "ValidationMessages.OnlyAlphanumericSpacesAllowed",
  numericValueFieldValidator: "ValidationMessages.NumericValueFieldValidator",
  valueRangeFieldValidator1To99:
    "ValidationMessages.ValueRangeFieldValidator1To99",
  fieldRequiredFieldValidator: "ValidationMessages.RequiredFieldValidator",
  alphabetOrSpecialCharNotAllowed:
    "ValidationMessages.AlphabetOrSpecialCharNotAllowed",
  specialCharNotAllowed: "ValidationMessages.SpecialCharNotAllowed",
  invalidValueValidator: "ValidationMessages.InvalidValueValidator",
  onlyAlphanumericAndSpaceAreAllowed:
    "ValidationMessages.OnlyAlphanumericAndSpaceAreAllowed",
  onlyNumericAndHyphenAreAllowed:
    "ValidationMessages.OnlyNumericAndHyphenAreAllowed",
  invalidEmail: "ValidationMessages.InvalidEmail",
  invalidLabelName: "ValidationMessages.InvalidLabelName",
  invalidPhoneNumber: "ValidationMessages.InvalidPhoneNumber",
  phoneNumberMinimumOf3DigitsRequiredMessage:
    "ValidationMessages.PhoneNumberMinimumOf3DigitsRequiredMessage",
  greaterThanZeroFieldValidator:
    "ValidationMessages.GreaterThanZeroFieldValidator",
  mustBe11Digits: "ValidationMessages.MustBe11Digits",
  mustBe13Digits: "ValidationMessages.MustBe13Digits",
  alphabetNotAllowedValidator: "ValidationMessages.AlphabetNotAllowedValidator",

  alphanumericFieldValidator: "ValidationMessages.AlphanumericFieldValidator",
  onlyAlphanumericSpacesAndHyphenAllowed:
    "ValidationMessages.OnlyAlphanumericSpacesAndHyphenAllowed",
  pleaseChooseAPastDate: "ValidationMessages.PleaseChooseAPastDate",
  pleaseChooseAFutureDate: "ValidationMessages.PleaseChooseAFutureDate",
  minimumOf20CharactersRequired:
    "ValidationMessages.MinimumOf20CharactersRequired",
  durationRequiredErrorMessage:
    "ValidationMessages.DurationRequiredErrorMessage",
  invalidDate: "ValidationMessages.InvalidDate",

  //dropdown common key
  statusAll: "Status.All",
  resetAllSearch: "Common.ResetAllSearch",
  submit: "Common.Submit",
  numberAndSpecialCharNotAllowed:
    "ValidationMessages.NumberAndSpecialCharNotAllowed",
  overWritingFilter: "Common.OverwritingFilter",
  alphabetFieldValidator: "ValidationMessages.AlphabetFieldValidator",
  back: "Common.Back",
  cancelConfirmationText: "Common.CancelConfirmationText",
  selected: "Common.Selected",
  totalPercentageMustEqual100: "ValidationMessages.TotalPercentageMustEqual100",
  pleaseEnterOnlyPositiveNumber:
    "ValidationMessages.PleaseEnterOnlyPositiveNumber",
  pleaseEnterNumberBetween1To100:
    "ValidationMessages.PleaseEnterNumberBetween_1To100",
  pleaseEnterNumberBetween1To500:
    "ValidationMessages.TheNumberMustBeBetween1And500",
  pleaseEnterNumberBetween1To600:
    "ValidationMessages.TheNumberMustBeBetween1To600",
  fieldSpecialCharactersTooltipMessage:
    "ValidationMessages.FieldSpecialCharactersTooltipMessage",
  fieldContainsInvalidCharactersErrorMessage:
    "ValidationMessages.FieldContainsInvalidCharactersErrorMessage",
  allowedSpecialCharacters: "ValidationMessages.AllowedSpecialCharacters",

  none: "Common.None",
  version: "Common.Version",
  yesProceed: "Common.YesProceed",
  proceed: "Common.Proceed",
  saveAndNextButtonText: "Common.SaveAndNextButtonText",
  day: "Common.Day",
  days: "Common.Days",
  done: "Common.Done",
  browse: "Common.Browse",
  dropYourFile: "Common.DropYourFile",
  browseImage: "Common.BrowseImage",
  monthPlaceHolder: "Common.MonthPlaceholderText",
  yearPlaceHolder: "Common.YearPlaceholderText",

  //below are Tax Details label key
  taxDetails: "Common.TaxDetails",
  addTaxHeading: "TaxDetails.AddTaxHeading",
  tax: "TaxDetails.Tax",
  taxPercentage: "TaxDetails.Percentage",
  taxAmount: "TaxDetails.Amount",
  totalTaxAmount: "TaxDetails.TotalTaxAmount",
  itemDescriptionTableColumn: "TaxDetails.ItemDescriptionTableColumn",
  percentageTableColumn: "TaxDetails.PercentageTableColumn",
  amountTableColumn: "TaxDetails.AmountTableColumn",
  actionTableColumn: "TaxDetails.ActionTableColumn",
  noTaxAvailablePleaseAddTheRequiredTaxDetailsManually:
    "TaxDetails.NoTaxAvailablePleaseAddTheRequiredTaxDetailsManually",
  areYouSureYouWantToDeleteTheTax: "TaxDetails.AreYouSureYouWantToDeleteTheTax",

  //below are Billing Configuration Details label key
  billingConfigurationDetails: "Common.BillingConfigurationDetails",
  configurationDetailsScheduledBasedHeading:
    "BillingConfigurationDetails.ConfigurationDetailsScheduledBasedHeading",
  configurationDetailsMilestoneBasedHeading:
    "BillingConfigurationDetails.ConfigurationDetailsMilestoneBasedHeading",
  schedulePeriod: "BillingConfigurationDetails.SchedulePeriod",
  value: "BillingConfigurationDetails.Value",
  addScheduleSubHeading: "BillingConfigurationDetails.AddScheduleSubHeading",
  editScheduleSubHeading: "BillingConfigurationDetails.EditScheduleSubHeading",
  addMilestoneSubHeading: "BillingConfigurationDetails.AddMilestoneSubHeading",
  editMilestoneSubHeading:
    "BillingConfigurationDetails.EditMilestoneSubHeading",
  schedule: "BillingConfigurationDetails.Schedule",
  milestone: "BillingConfigurationDetails.Milestone",
  scheduleNumber: "BillingConfigurationDetails.ScheduleNumber",
  milestoneNumber: "BillingConfigurationDetails.MilestoneNumber",
  feePercentage: "BillingConfigurationDetails.FeePercentage",
  billingConfigurationAmount: "BillingConfigurationDetails.Amount",
  scheduleFrequency: "BillingConfigurationDetails.ScheduleFrequency",
  totalPercentage: "BillingConfigurationDetails.TotalPercentage",
  totalAmount: "BillingConfigurationDetails.TotalAmount",
  scheduleTableColumnHeading:
    "BillingConfigurationDetails.ScheduleTableColumnHeading",
  percentageTableColumnHeading:
    "BillingConfigurationDetails.PercentageTableColumnHeading",
  amountTableColumnHeading:
    "BillingConfigurationDetails.AmountTableColumnHeading",
  scheduleFrequencyTableColumnHeading:
    "BillingConfigurationDetails.ScheduleFrequencyTableColumnHeading",
  statusTableColumnHeading:
    "BillingConfigurationDetails.StatusTableColumnHeading",
  actionTableColumnHeading:
    "BillingConfigurationDetails.ActionTableColumnHeading",
  noMilestonesFoundMessage:
    "BillingConfigurationDetails.NoMilestonesFoundMessage",
  noSchedulesFoundMessage:
    "BillingConfigurationDetails.NoSchedulesFoundMessage",
  activities: "BillingConfigurationDetails.Activities",
  milestoneTableColumnHeading:
    "BillingConfigurationDetails.MilestoneTableColumnHeading",
  activitiesTableColumnHeading:
    "BillingConfigurationDetails.ActivitiesTableColumnHeading",
  amountCannotGreaterThanProgramFeeErrorMessage:
    "BillingConfigurationDetails.AmountCannotGreaterThanProgramFeeErrorMessage",
  totalPercentageCannotExceed100:
    "BillingConfigurationDetails.TotalPercentageCannotExceed100",
  totalAmountMustEqualProgramFeeErrorMessage:
    "BillingConfigurationDetails.TotalAmountMustEqualProgramFeeErrorMessage",
  selectFrequencyThatFallsBetweenThePreviousAndNextSchedules:
    "BillingConfigurationDetails.SelectFrequencyThatFallsBetweenThePreviousAndNextSchedules",
  selectedFrequencyMustBeLowerThanThePreviouslyAddedSchedules:
    "BillingConfigurationDetails.SelectedFrequencyMustBeLowerThanThePreviouslyAddedSchedules",
  pleaseCreateMoreThanOneScheduleAndDistributeTheAmountAccordingly:
    "BillingConfigurationDetails.PleaseCreateMoreThanOneScheduleAndDistributeTheAmountAccordingly",
  billingStatusList: "BillingConfigurationDetails.BillingStatusList",
  scheduleFrequencyMonthlyList:
    "BillingConfigurationDetails.ScheduleFrequencyMonthlyList",
  scheduleFrequencyWeeklyList:
    "BillingConfigurationDetails.ScheduleFrequencyWeeklyList",
  schedulePeriodList: "BillingConfigurationDetails.SchedulePeriodList",
  valueList: "BillingConfigurationDetails.ValueList",

  pleaseFillProgramFeeErrorMessage:
    "BillingConfigurationDetails.PleaseFillProgramFeeErrorMessage",
  areYouSureYouWantToDeleteTheMilestone:
    "BillingConfigurationDetails.AreYouSureYouWantToDeleteTheMilestone",
  areYouSureYouWantToDeleteTheSchedule:
    "BillingConfigurationDetails.AreYouSureYouWantToDeleteTheSchedule",
  countryRequired: "ValidationMessages.CountryRequired",
  minutesRequired: "ValidationMessages.MinutesRequired",
  totalAmountMustEqualProjectFeeErrorMessage:
    "BillingConfigurationDetails.TotalAmountMustEqualProjectFeeErrorMessage",
  pleaseFillProjectFeeErrorMessage:
    "BillingConfigurationDetails.PleaseFillProjectFeeErrorMessage",
  amountCannotGreaterThanProjectFeeErrorMessage:
    "BillingConfigurationDetails.AmountCannotGreaterThanProjectFeeErrorMessage",
};
export const commonSiteCoreAccessDeniedLabelKeys = {
  accessDeniedParentKey: "Common.AccessDenied",
  accessDeniedTitle: "Common.AccessDenied.AccessDeniedTitle",
  accessDeniedDescription: "Common.AccessDenied.AccessDeniedDescription",
  backToDashboardButton: "Common.AccessDenied.BackToDashboardButton",
  accessDeniedImage: "Common.AccessDenied.AccessDeniedImage",
};

export const commonSiteCoreARIALabelKeys = {
  ariaLabelDetails: "Common.ARIALabelDetails",
  closeModalWindow: "Common.ARIALabelDetails.CloseModalWindow",
  closePopover: "Common.ARIALabelDetails.ClosePopover",
  collapseAccordion: "Common.ARIALabelDetails.CollapseAccordion",
  collapseLeftNavigation: "Common.ARIALabelDetails.CollapseLeftNavigation",
  collapseNavigationSubMenu:
    "Common.ARIALabelDetails.CollapseNavigationSubMenu",
  decreaseFontSize: "Common.ARIALabelDetails.DecreaseFontSize",
  defaultFontSize: "Common.ARIALabelDetails.DefaultFontSize",
  deleteException: "Common.ARIALabelDetails.DeleteException",
  column: "Common.ARIALabelDetails.Column",
  expandAccordion: "Common.ARIALabelDetails.ExpandAccordion",
  expandLeftNavigation: "Common.ARIALabelDetails.ExpandLeftNavigation",
  expandNavigationSubMenu: "Common.ARIALabelDetails.ExpandNavigationSubMenu",
  goToNextPage: "Common.ARIALabelDetails.GoToNextPage",
  goToNextPageDisabled: "Common.ARIALabelDetails.GoToNextPageDisabled",
  goToPage: "Common.ARIALabelDetails.GoToPage",
  goToPreviousPage: "Common.ARIALabelDetails.GoToPreviousPage",
  goToPreviousPageDisabled: "Common.ARIALabelDetails.GoToPreviousPageDisabled",
  goToDashboard: "Common.ARIALabelDetails.GoToDashboard",
  increaseFontSize: "Common.ARIALabelDetails.IncreaseFontSize",
  labelNameChecked: "Common.ARIALabelDetails.LabelNameChecked",
  labelNameRadioButtonSelected:
    "Common.ARIALabelDetails.LabelNameRadioButtonSelected",
  labelNameRadioButtonUnSelected:
    "Common.ARIALabelDetails.LabelNameRadioButtonUnSelected",
  labelNameUnchecked: "Common.ARIALabelDetails.LabelNameUnchecked",
  moreOptionsForThisTableRow:
    "Common.ARIALabelDetails.MoreOptionsForThisTableRow",
  noneSorted: "Common.ARIALabelDetails.NoneSorted",
  openProfileMenu: "Common.ARIALabelDetails.OpenProfileMenu",
  profilePictureOf: "Common.ARIALabelDetails.ProfilePictureOf",
  readMore: "Common.ARIALabelDetails.ReadMore",
  removeChipName: "Common.ARIALabelDetails.RemoveChipName",
  search: "Common.ARIALabelDetails.Search",
  searchMenuItems: "Common.ARIALabelDetails.SearchMenuItems",
  selectDate: "Common.ARIALabelDetails.SelectDate",
  selectLanguageCurrentlySelected:
    "Common.ARIALabelDetails.SelectLanguageCurrentlySelected",
  showMoreDetails: "Common.ARIALabelDetails.ShowMoreDetails",
  showNMore: "Common.ARIALabelDetails.ShowNMore",
  sortAscending: "Common.ARIALabelDetails.SortAscending",
  sortDescending: "Common.ARIALabelDetails.SortDescending",
  viewMore: "Common.ARIALabelDetails.ViewMore",
  viewMoreOptions: "Common.ARIALabelDetails.ViewMoreOptions",
  viewNewNotifications: "Common.ARIALabelDetails.ViewNewNotifications",
  viewNotes: "Common.ARIALabelDetails.ViewNotes",
  viewNotifications: "Common.ARIALabelDetails.ViewNotifications",
  required: "Common.ARIALabelDetails.Required",
  goToSelectedPage: "Common.ARIALabelDetails.GoToSelectedPage",
  // Client Results
  clientResultEditIcon: "Common.ARIALabelDetails.ClientResults.EditIcon",
  panTowardsDown:
    "Common.ARIALabelDetails.ClientResults.Hierarchy.PanTowardsDown",
  panTowardsLeft:
    "Common.ARIALabelDetails.ClientResults.Hierarchy.PanTowardsLeft",
  panTowardsRight:
    "Common.ARIALabelDetails.ClientResults.Hierarchy.PanTowardsRight",
  panTowardsUp: "Common.ARIALabelDetails.ClientResults.Hierarchy.PanTowardsUp",
  viewAsList: "Common.ARIALabelDetails.ClientResults.Hierarchy.ViewAsList",
  viewHierarchy: "Common.ARIALabelDetails.ClientResults.ViewHierarchy",
  zoomIn: "Common.ARIALabelDetails.ClientResults.Hierarchy.ZoomIn",
  zoomOut: "Common.ARIALabelDetails.ClientResults.Hierarchy.ZoomOut",
  closeNavigationMenu: "Common.ARIALabelDetails.CloseNavigationMenu",
  openNavigationMenu: "Common.ARIALabelDetails.OpenNavigationMenu",
  copyToClipboard: "Common.ARIALabelDetails.CopyToClipboard",
  delete: "Common.ARIALabelDetails.Delete",
  edit: "Common.ARIALabelDetails.Edit",
  checked: "Common.ARIALabelDetails.Checked",
  unchecked: "Common.ARIALabelDetails.Unchecked",
  selectRowItemName: "Common.ARIALabelDetails.SelectRowItemName",
  selectAll: "Common.ARIALabelDetails.SelectAll",
  pageNumber: "Common.ARIALabelDetails.PageNumber",
  selectRow: "Common.ARIALabelDetails.SelectRow",
  metricsCarousel: "Common.ARIALabelDetails.MetricsCarousel",
  scrollLeft: "Common.ARIALabelDetails.ScrollLeft",
  scrollRight: "Common.ARIALabelDetails.ScrollRight",
};

export const navigationMenuSiteCoreKeys = {
  navigationMenu: "NavigationMenu",
  dashboard: "NavigationMenu.Dashboard",
  candidatesManagement: "CandidatesManagementSubMenu",
  candidate: "NavigationMenu.Candidate",
  usersManagement: "UsersManagementSubMenu",
  users: "NavigationMenu.Users",
  clientManagement: "ClientManagementSubMenu",
  project: "ProjectsSubMenu",
  searchProject: "ProjectsSubMenu.SearchProjects",
  createProject: "ProjectsSubMenu.CreateNewProject",
  clients: "NavigationMenu.Clients",
  searchClient: "NavigationMenu.SearchClient",
  createClient: "NavigationMenu.CreateClient",
  programTemplateManagement: "ProgramTemplateManagementSubMenu",
  coachPortalParticipantsManagement: "ParticipantsSubMenu",
  coachPortalParticipantsCollapseModeIcon: "Participants.CollapseModeIcon",
  coachPortalParticipantsExpandModeIcon: "Participants.ExpandModeIcon",
  createProgramTemplate: "NavigationMenu.CreateProgramTemplate",
  searchProgramTemplate: "NavigationMenu.SearchProgramTemplate",
  dataAndSettings: "NavigationMenu.DataAndSettings",
  programAndCandidates: "ProgramandCandidatesSubMenu",
  searchProgranAndCandidate:
    "ProgramandCandidatesSubMenu.SearchProgramandCandidate",
  createProgram: "ProgramandCandidatesSubMenu.CreateProgram",
  createNISParticipant: "ProgramandCandidatesSubMenu.CreateNewNISParticipant",
  createNIP3Candidate: "ProgramandCandidatesSubMenu.CreateNIP3Candidate",
  clientPortalSubMenu: "ClientPortalSubMenuComponent",
  clientAccounts: "ClientPortalSubMenu.ClientAccounts",
  reports: "ClientPortalSubMenu.Reports",
  resources: "ClientPortalSubMenu.Resources",
  referrals: "ClientPortalSubMenu.Referrals",
  clientUsers: "ClientPortalSubMenu.ClientUsers",
  accountTeam: "ClientPortalSubMenu.AccountTeam",
  adminMessages: "ClientPortalSubMenu.AdminMessages",
  meetingRequests: "ClientPortalSubMenu.MeetingRequests",
  masterDataSubMenu: "MasterDataSubMenu",
  activity: "MasterDataSubMenu.Activity",
  office: "MasterDataSubMenu.Office",
  smallImage: "SmallImage",
  dashboardCollapseModeIcon: "Dashboard.CollapseModeIcon",
  dashboardExpandModeIcon: "Dashboard.ExpandModeIcon",
  userManagementCollapseModeIcon: "UserManagement.CollapseModeIcon",
  userManagementExpandModeIcon: "UserManagement.ExpandModeIcon",
  clientManagementCollapseModeIcon: "ClientManagement.CollapseModeIcon",
  clientManagementExpandModeIcon: "ClientManagement.ExpandModeIcon",
  projectCollapseModeIcon: "ProjectsSubMenu.CollapseModeIcon",
  projectExpandModeIcon: "ProjectsSubMenu.ExpandModeIcon",
  programsAndParticipantsCollapseModeIcon:
    "ProgramsandParticipants.CollapseModeIcon",
  programsAndParticipantsExpandModeIcon:
    "ProgramsandParticipants.ExpandModeIcon",
  programTemplateManagementCollapseModeIcon:
    "ProgramTemplateManagement.CollapseModeIcon",
  programTemplateManagementExpandModeIcon:
    "ProgramTemplateManagement.ExpandModeIcon",
  clientPortalSetupCollapseModeIcon: "ClientPortalSetup.CollapseModeIcon",
  clientPortalSetupExpandModeIcon: "ClientPortalSetup.ExpandModeIcon",
  masterDataCollapseModeIcon: "MasterData.CollapseModeIcon",
  masterDataExpandModeIcon: "MasterData.ExpandModeIcon",
  manageBulkProcess: "ProgramandCandidatesSubMenu.ManageBulkProcess",
  bulkProcess: "ProgramandCandidatesSubMenu.BulkProcess",
  bulkCreateProgram: "ProgramandCandidatesSubMenu.BulkCreateProgram",
  bulkEditProgram: "ProgramandCandidatesSubMenu.BulkEditProgram",
  bulkInsertActivity: "ProgramandCandidatesSubMenu.BulkInsertActivity",
  bulkTransferParticipants:
    "ProgramandCandidatesSubMenu.BulkTransferParticipants",
  permissionAndMessagesSubmenu: "PermissionAndMessagesSubmenu",
  permissionAndMessagesCollapseModeIcon:
    "PermissionAndMessages.CollapseModeIcon",
  permissionAndMessagesExpandModeIcon: "PermissionAndMessages.ExpandModeIcon",
  usersSubmenu: "PermissionAndMessagesSubmenu.Users",
  systemMessages: "PermissionAndMessagesSubmenu.SystemMessages",
  coachPortalManagement: "CoachPortalManagementSubMenu",
  coachPortalDashboard: "CoachPortalManagementSubMenu.Dashboard",
  coachPortalParticipants: "CoachPortalManagementSubMenu.Participants",
};

export const reportMenuSiteCoreKey = {
  ReportsSubMenu: "ReportsSubMenu",
  smallImage: "SmallImage",
  expandModeIcon: "Reports.ExpandModeIcon",
  collapseModeIcon: "Reports.CollapseModeIcon",
};

export const genericAccountsSiteCoreKey = {
  genericAccountsSubMenu: "GenericAccountsSubMenu",
  smallImage: "SmallImage",
  expandModeIcon: "GenericAccountsSubMenu.ExpandModeIcon",
  collapseModeIcon: "GenericAccountsSubMenu.CollapseModeIcon",
  createNewGenericAccount: "GenericAccountsSubMenu.CreateNewGenericAccount",
  searchGenericAccounts: "GenericAccountsSubMenu.SearchGenericAccounts",
};

export const UnitTypesKey = {
  Minutes: "Units.Minutes",
  Count: "Units.Count",
  Days: "Units.Days",
  HalfDay: "Units.HalfDay",
};

export const ManageLocaleKey = {
  englishUsName: LANGUAGE_CODE.EN_US,
  englishUkName: LANGUAGE_CODE.EN_GB,
  japaneseName: LANGUAGE_CODE.JA_JP,
  french: LANGUAGE_CODE.FR_FR,
  brazilian: LANGUAGE_CODE.PT_BR,
};

export const localeFields = (commonLabels: KeyValueMap) => [
  {
    key: ManageLocaleKey.englishUsName, // key name is same as value "en-us"
    placeholderKey: commonLabels.inputPlaceHolder,
  },
  {
    key: ManageLocaleKey.englishUkName,
    placeholderKey: commonLabels.inputPlaceHolder,
    isEnglish: true,
  },
  {
    key: ManageLocaleKey.french,
    placeholderKey: commonLabels.frenchPlaceholder,
  },
  {
    key: ManageLocaleKey.brazilian,
    placeholderKey: commonLabels.brazilPlaceholder,
  },
  {
    key: ManageLocaleKey.japaneseName,
    placeholderKey: commonLabels.japanesePlaceholder,
  },
];
